import { createAsyncThunk } from "@reduxjs/toolkit"
import { post, del, patch } from "helpers/api_helper"
import {
  DELETE_BOOKING,
  GET_ALL_BOOKINGS,
  GET_BOOKING_DETAILS,
  UPDATE_BOOKING_STATUS,
} from "helpers/url_helper"

export const getAllBookings = createAsyncThunk(
  GET_ALL_BOOKINGS,
  async payload => {
    const response = await post(GET_ALL_BOOKINGS, payload)
    return response
  }
)

export const getBookingDetails = createAsyncThunk(
  GET_BOOKING_DETAILS,
  async payload => {
    const response = await post(GET_BOOKING_DETAILS, payload)
    return response
  }
)

export const updateBookingStatus = createAsyncThunk(
  UPDATE_BOOKING_STATUS,
  async payload => {
    const response = await patch(UPDATE_BOOKING_STATUS, payload)
    return response
  }
)

export const deleteBooking = createAsyncThunk(DELETE_BOOKING, async payload => {
  const response = await del(`${DELETE_BOOKING}/${payload.id}`)
  return response
})
